import { AppSetting } from './app-setting';

export class NumberAppSetting extends AppSetting<number> {
  public constructor(protected _name: string, _default: number, protected _useStorage: boolean) {
    super(_name, _default, _useStorage);
  }
}
